module.exports = __webpack_public_path__ + "img/weixin-zgwhhlycy.0eda5fa2.png";